// extracted by mini-css-extract-plugin
var _1 = "ErrorPageInit-moduleErrorPageInit__lW2Fc";
var _2 = "ErrorPageInit-modulemessage__G5Ko6";
var _3 = "ErrorPageInit-moduleseparator__ogOdH";
var _4 = "ErrorPageInit-moduletext__UCipC";
var _5 = "ErrorPageInit-moduletitle__gEnNq";
export { _1 as "ErrorPageInit", _2 as "message", _3 as "separator", _4 as "text", _5 as "title" }
